<mat-dialog-content class="mat-typography">
    <h3>Recordá que para las PyMES que van a iniciarse en una nueva actividad no se financia Capital de Trabajo </h3>
</mat-dialog-content>
<mat-dialog-actions style="justify-content: center">
    <button mat-button mat-dialog-close class="boton-rojo-ftyc">Entendido</button>
</mat-dialog-actions>
